import { render, staticRenderFns } from "./StockMovementTable.vue?vue&type=template&id=e24a2e06&scoped=true&"
import script from "./StockMovementTable.vue?vue&type=script&lang=ts&"
export * from "./StockMovementTable.vue?vue&type=script&lang=ts&"
import style0 from "./StockMovementTable.vue?vue&type=style&index=0&id=e24a2e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24a2e06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VDivider,VTextField})
